module.exports = __webpack_public_path__ + "static/img/mainbk2.93bb965.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/mainbk2.jpg
// module id = f1J6
// module chunks = 1